<template>
  <v-wrapper>
    <div class="shortcuts">
      <div class="shortcuts__header">
        <h3>Acceso rápido a</h3>
      </div>
      <div class="shortcuts__options">
        <div>
          <router-link :to="`${path.toLowerCase()}/buscar/operacion-venta_1`">Ventas</router-link>
        </div>
        <div>
          <router-link class="active" :to="`${path.toLowerCase()}/buscar/operacion-permuta_4`">Permutas</router-link>
        </div>
        <div>
          <router-link :to="`${path.toLowerCase()}/buscar/operacion-alquiler_2`">Alquileres</router-link>
        </div>
        <div>
          <router-link :to="`${path.toLowerCase()}/buscar/operacion-temporario_3`">Temporarios</router-link>
        </div>
      </div>
    </div>
  </v-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import accents from '../helpers/accents'

export default {
    computed: {
        ...mapGetters({
            countries: 'countries/countries',
            country: 'countries/country',
            path: 'path'
        })
    }
}
</script>

<style lang="scss">
.shortcuts {
    // width: 100%;
    // max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
    // padding: 1rem;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr;
    // border-radius: 4px;
    // background-color: rgba(#ffffff, 0.6);
    &__header {
        display: flex;
        align-items: center;
        justify-content: center;
        h3 {
            margin-right: 0.5rem;
            display: inline-block;
            // font-weight: bold;
            font-size: 1.5rem;
            text-align: center;
            justify-content: center;
        }
    }
    &__options {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        overflow: hidden;
        // background-color: #ffffff;
        // box-shadow: 0 2px 4px 0 rgba(#000000, 0.2);
        div {
          display: flex;
          width: 25%;
          justify-content: center;
          a {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            width: 100%;
            padding-left: 1rem;
            padding-right: 1rem;
            margin: 1rem;
            font-size: 1.2rem;
            border-radius: 4px;
            color: #000000;
            background-color: #f3f3f3;
            // background-color: transparent;
            outline: none;
            border: none;
            // box-shadow: 0 px 4px 0 rgba(#000000, 0.2);
            &:hover {
              background-color: #c9d700;
              // background-color: #f3f3f3;
              color: #ffffff;
            }
            &.active {
              color: #ffffff;
              background-color: #c9d700;
            }
          }

        }
    }
    @media (max-width: 992px) {
        &__options {
            grid-gap: 0.5rem;
            grid-template-columns: 1fr;
        }
    }
    @media (max-width: 576px) {
      .shortcuts {
        // display: none;
        // &__header {display: none}
        &__options {
          flex-direction: column;
          // padding-top: 1rem;
          padding-bottom: 1rem;
          div {
            display: flex;
            width: 100%;
            justify-content: center;
            a {
              margin-top: 0.5rem;
              margin-bottom: 0.5rem;
            }
          }
        }
      }
    }
}
</style>
